<div class="login-dialog-container text-center">

  <mat-card-header class="dialog-header">
    <h3 class="welcome-text">{{ 'LOGIN.SIGN_IN' | transloco }}</h3>
  </mat-card-header>

  @if (!showSmsCode) {
  <div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="dialog-form">
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Email" formControlName="email" autofocus>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'LOGIN.PASSWORD' | transloco }}</mat-label>
        <input matInput placeholder="Password" formControlName="password" [type]="hidePassword ? 'password' : 'text'"
          autocomplete="off">
        <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" type="button">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-hint align="end" (click)="getNewPassword()" class="clickable">
          {{ 'LOGIN.FORGOT_PASSWORD' | transloco }}
        </mat-hint>
      </mat-form-field>
      <button mat-raised-button color="primary" class="submit-btn" [disabled]="loading || loginForm.invalid"
        type="submit">
        @if (loading) {
        <mat-icon>
          <mat-spinner color="accent" diameter="20">
          </mat-spinner>
        </mat-icon>
        }
        {{ ('LOGIN.SIGN_IN' | transloco) | uppercase }}
      </button>
      @if (hasBeenLoggedIn) {
      <div>
        <button mat-stroked-button class="cancel-btn" type="button" (click)="goToStart()">
          {{ ('LOGIN.CANCEL' | transloco) | uppercase }}
        </button>
      </div>
      }
    </form>
  </div>
  }

  @if (showSmsCode) {
  <div>
    @if (smsTimer > 0 ) {
    <div>
      <form [formGroup]="loginSmsForm" (ngSubmit)="onSubmit()" class="mt-4">
        <span>{{'LOGIN.CODE_SENT' | transloco}}</span>
        @if (0 >= oneMinuteTimer && smsTimer > 0) {
        <div class="mt-2 mb-2">
          {{'LOGIN.CODE_EXPIRES_IN' | transloco}} {{ formatTimer() }}
        </div>
        }
        <mat-form-field appearance="outline" class="mt-3">
          <mat-label>
            {{'LOGIN.SMS_CODE' | transloco}}
          </mat-label>
          <input matInput placeholder="{{'LOGIN.STATUS.ENTER_SMS_CODE' | transloco}}" formControlName="smsCode"
            tabindex="1" #smsInput>
        </mat-form-field>
        <br>
        <button mat-raised-button color="primary" class="sms-submit-btn" [disabled]="loading || loginSmsForm.invalid"
          type="submit">
          {{ ('LOGIN.SIGN_IN' | transloco) | uppercase }}
        </button>
        @if (oneMinuteTimer > 0) {
        <div class="mt-3">
          <span>{{'LOGIN.DIDNT_RECEIVE_CODE' | transloco}}</span>
          <span class="resend-timer">{{'LOGIN.RESEND_IN' |
            transloco}} {{ formatOneMinuteTimer() }}</span>
        </div>
        }
      </form>
    </div>
    }
    @if (0 >= smsTimer || 0 >= oneMinuteTimer) {
    <div class="mt-4">
      @if(smsTimer > 0){
      <p class="full-width" (click)="resendSms()">
        {{'LOGIN.STATUS.SMS_CODE_NOT_RECEIVED' | transloco }}
        <a>
          {{'LOGIN.RESEND_SMS_CODE' | transloco }}
        </a>
      </p>
      }
      @else{
      <button mat-raised-button color="primary" class="resend-btn" (click)="resendSms()" type="button">
        {{('LOGIN.RESEND_SMS_CODE' | transloco) | uppercase }}
      </button>
      <button mat-raised-button class="go-back-btn" (click)="showSmsCode=false" type="button">
        {{('LOGIN.GO_BACK' | transloco) | uppercase }}
      </button>
      }
    </div>
    }
  </div>
  }
</div>